import * as types from '../mutations';

export default {
	namespaced: true,

	state: {
		messages: [],
	},

	actions: {
		fetchAll({ rootState, commit }) {
			return window.axios
				.get(
					`center/${rootState.login.activeUser.centerId}/students/${rootState.login.activeUser.userName}/messages`,
				)
				.then((res) => {
					commit(types.MESSAGES, res.data);
					return res.data;
				});
		},
		sendMessage({ rootState }, { message, image, isParent }) {
			const formData = new FormData();
			formData.append('IsParent', isParent);
			if (message) formData.append('Content', message);
			if (image) formData.append('ImagePath', image);

			return window.axios.post(
				`center/${rootState.login.activeUser.centerId}/students/${rootState.login.activeUser.userName}/send-message`,
				formData,
			);
		},
	},

	mutations: {
		[types.MESSAGES](state, messages) {
			state.messages = messages;
		},
	},
};
